import type { MessageTree } from "./th-TH"

export const myMM: MessageTree = {
  nav: {
    menu: "မီနူး",
    solutions: "ဖြေရှင်းချက်များ",
    guides: "ဗဟုသုတ",
    shop: "ဆိုင်",
    used: "အသုံးပြုပြီး",
    ecosystem: "ဆော့ဖ်ဝဲလ်အုပ်စု",
    account: "အကောင့်",
    cart: "ခြင်းတောင်း",
    home: "ပင်မစာမျက်နှာ",
    contact: "ဆက်သွယ်ရန်",
    language: "ဘာသာစကား",
    searchOpen: "ရှာဖွေရန်",
    searchClose: "ရှာဖွေမှုပိတ်ရန်",
  },
  chat: {
    askProducts: "ကုန်ပစ္စည်းမေးရန်",
    team: "အဖွဲ့နှင့် စကားပြောရန်",
    line: "LINE",
    modeAssistant: "ကုန်ပစ္စည်းမေးရန်",
    modeTeam: "အဖွဲ့နှင့် စကားပြောရန်",
    modeLine: "LINE",
    subtitleAssistant: "ကုန်ပစ္စည်းရှာပြီး ကတ်တလောက်မေးခွန်းများ ဖြေပေးသည်",
    subtitleTeam: "VX Work အဖွဲ့ထံ စာပို့ရန်",
    subtitleLine: "LINE Official Account မှ VX Work အဖွဲ့နှင့် စကားပြောရန်",
    greeting: "မင်္ဂလာပါ — ယနေ့ ကတ်တလောက်ထဲမှ ဘာရှာပေးရမလဲ",
    greetingHint:
      "မော်ဒယ်၊ စပက် သို့မဟုတ် ဘတ်ဂျက် မေးနိုင်ပါတယ် — ဆိုင်ရှိ ကုန်ပစ္စည်းမှ ရှာပေးပါမယ်",
    teamHint: "ကုန်ပစ္စည်း၊ ဝန်ဆောင်မှု သို့မဟုတ် ကိုးကားချက် မေးနိုင်ပါတယ်",
    placeholderAssistant: "မေးခွန်းရိုက်ပါ သို့မဟုတ် အပေါ်မှ ခေါင်းစဉ်ရွေးပါ…",
    placeholderTeam: "အဖွဲ့ထံ ရိုက်ပါ ဥပမာ CRS328 စတော့ရှိလား",
    lineTitle: "LINE Official Account",
    lineBody: "LINE တွင် VX Work အဖွဲ့နှင့် စကားပြောရန်",
    lineCta: "LINE စကားပြော ယခုစတင်ရန်",
    lineHint: "LINE အက်ပ်မှ တိုက်ရိုက်စကားပြောလိုပါက အောက်မှ နှိပ်ပါ",
    close: "ချတ်ပိတ်ရန်",
    clear: "ချတ်ရှင်းရန်",
    unavailable: "အကူအညီပေးသူ မရရှိနိုင်သေးပါ။ နောက်မှ ထပ်ကြိုးစားပါ",
    connectFailed: "အကူအညီပေးသူနှင့် ချိတ်ဆက်မရပါ။ ထပ်ကြိုးစားပါ",
    errorGeneric: "အကူအညီပေးသူဆက်သွယ်ရာတွင် အမှားဖြစ်ပါသည်။ ထပ်ကြိုးစားပါ",
  },
  home: {
    metaTitle: "VX Work — ကွန်ရက်ဖြေရှင်းချက်နှင့် ဆော့ဖ်ဝဲလ်",
    metaDescription:
      "ဟိုတယ်နှင့် ရုံးများအတွက် ကွန်ရက်ဗဟုသုတနှင့် ဖြေရှင်းချက်များ၊ စက်ပစ္စည်းဆိုင်နှင့် KEOS ကဲ့သို့ ဆော့ဖ်ဝဲလ်များ",
    solutionsCta: "ဖြေရှင်းချက်များကြည့်ရန် →",
    shopCta: "ဆိုင်ဖွင့်ရန်",
    whatsNewTitle: "ဆိုင်ထဲမှ အသစ်များ",
    whatsNewBody: "ကတ်တလောက်မှ စိတ်ဝင်စားဖွယ် မော်ဒယ်များ — စပက်ကြည့်ပြီး အဖွဲ့နှင့် တိုင်ပင်နိုင်သည်",
    whatsNewCta: "ဆိုင်ဖွင့်ရန် →",
  },
  footer: {
    blurb: "ဟိုတယ်၊ ရုံးနှင့် SME များအတွက် ကွန်ရက်ဖြေရှင်းချက်နှင့် ဆော့ဖ်ဝဲလ်အချက်အချာ —",
    solutions: "ဖြေရှင်းချက်များ",
    shop: "ဆိုင်",
  },
}
